<template>
    <div class="text-md-center h-100 radius-20 py-3 text-left bg-utel-v2-secondary">
        <h3 class="stepper-title ms-4 ms-md-">Nuevo curso</h3>
        <div class="stepper d-flex justify-content-between flex-md-column flex-row">
            <div class="step row" :class="{ 'active-step': activeStep == 1 }">
                <div class="col-sm-3">
                    <div class="step-number">
                        <p class="mb-0">1</p>
                    </div>
                </div>
                <div class="col-sm-9">
                    <div class="step-title">
                        <p class="mb-0">Información del curso</p>
                    </div>
                </div>
            </div>
            <div class="step-divider d-md-block d-none" :class="{ 'active-divider': activeStep == 1 }"></div>
            <div class="step row" :class="{ 'active-step': activeStep == 2 }">
                <div class="col-sm-3">
                    <div class="step-number">
                        <p class="mb-0">2</p>
                    </div>
                </div>
                <div class="col-sm-9">
                    <div class="step-title">
                        <p class="mb-0">Carga de contenido</p>
                    </div>
                </div>
            </div>
            <div class="step-divider d-md-block d-none" :class="{ 'active-divider': activeStep == 2 }"></div>
            <div class="step row" :class="{ 'active-step': activeStep == 3 }">
                <div class="col-sm-3">
                    <div class="step-number">
                        <p class="mb-0">3</p>
                    </div>
                </div>
                <div class="col-sm-9">
                    <div class="step-title">
                        <p class="mb-0">Curso creado con éxito</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        props: ['activeStep']
    }
</script>
<style>
    .stepper-title{
        color: #1A0054;
        text-align: center;
        font-weight: 700;
    }

    .stepper .step{
        align-items: center;
        margin: 0 30px;
    }
    .stepper .step .step-number{
        background-color: #CBB9FF99;
        border-radius: 50%;
        padding: 15px;
        font-weight: bold;
        color: #9164FF;
        font-size: 25px;
        width: 45px;
        height: 45px;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .stepper .step .step-title{
        color: #6B6876;
        font-size: 16px;
    }

    .stepper .step-divider{
        width: 10px;
        height: 60px;
        background-color: #CBB9FF99;
        border-radius: 20px;
        margin-bottom: 20px;
        margin-top: 5px;
        margin-left: 60px;
    }

    .radius-20{
        border-radius: 20px;
    }

    .active-divider{
        background-color: #D537ED !important;
    }

    .active-step .step-number{
        background-color: #D537ED !important;
        color: #1A0054 !important;
    }

    .active-step .step-title{
        color: #1A0054 !important;
    }


    @media(max-width: 576px){
        .stepper .step{
            margin: 0;
            text-align: center;
        }

        .stepper .step .step-number{
            margin: auto;
        }

        .stepper .step .step-title{
            margin: auto;
            font-size: 11px;
            max-height: 36px;
        }

        .stepper-title{
            text-align: left;
        }
    }

</style>
